import classes from "./Itinerary.module.css";

export const Itinerary = ({ itineraryViewModel }) => {
  // console.log(itinerary)

  return (
    <>
      <div className={classes["itinerary-container"]}>
        <p className={classes["itinerary-heading"]}>ITINERARY</p>
        {itineraryViewModel.itineraryList.map((it, index) => {
          if ((index + 1) % 2 === 0) {
            return <div key={index} />;
          } else {
            if ((index + 1) % 4 === 1) {
              return (
                <div key={index} className={classes["day-container"]}>
                  <div className={classes["day-text-container"]}>
                    <p className={classes["day-text-heading"]}>{it.heading}</p>
                    <ol style={{ listStyleType: "disc" }}>
                      {it.desc.map((dc, index) => {
                        return (
                          <li key={index} className={classes["day-text-desc"]}>
                            {dc}
                          </li>
                        );
                      })}
                    </ol>
                    {index + 2 <= itineraryViewModel.itineraryList.length ? (
                      <>
                        {" "}
                        <p className={classes["day-text-heading"]}>
                          {itineraryViewModel.itineraryList[index + 1].heading}
                        </p>
                        <ol style={{ listStyleType: "disc" }}>
                          {itineraryViewModel.itineraryList[index + 1].desc.map(
                            (dc, index) => {
                              return (
                                <li
                                  key={index}
                                  className={classes["day-text-desc"]}
                                >
                                  {dc}
                                </li>
                              );
                            }
                          )}
                        </ol>
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                  <img
                    className={classes["day-img-container"]}
                    src={it.img}
                    alt=""
                  />
                </div>
              );
            } else {
              return (
                <div className={classes["day-container"]}>
                  <img
                    className={classes["day-img-container"]}
                    src={it.img}
                    alt=""
                  />
                  <div className={classes["day-text-container"]}>
                    <p className={classes["day-text-heading"]}>{it.heading}</p>
                    <ol style={{ listStyleType: "disc" }}>
                      {it.desc.map((dc, index) => {
                        return (
                          <li key={index} className={classes["day-text-desc"]}>
                            {dc}
                          </li>
                        );
                      })}
                    </ol>
                    {index + 2 <= itineraryViewModel.itineraryList.length ? (
                      <>
                        <p className={classes["day-text-heading"]}>
                          {itineraryViewModel.itineraryList[index + 1].heading}
                        </p>
                        <ol style={{ listStyleType: "disc" }}>
                          {itineraryViewModel.itineraryList[index + 1].desc.map(
                            (dc, index) => {
                              return (
                                <li
                                  key={index}
                                  className={classes["day-text-desc"]}
                                >
                                  {dc}
                                </li>
                              );
                            }
                          )}
                        </ol>
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              );
            }
          }
        })}
        <div className={classes["day-trips-container"]}>
          {itineraryViewModel.itineraryList.map((it, index) => {
            return (
              <div key={index} className={classes["mobile-day-container"]}>
                <div className={classes["day-text-container"]}>
                  <p className={classes["day-text-heading"]}>{it.heading}</p>
                  <ol
                    style={{
                      listStyleType: "disc",
                      paddingLeft: "3vw",
                      marginTop: "2vw",
                    }}
                  >
                    {it.desc.map((dc, index) => {
                      return (
                        <li key={index} className={classes["day-text-desc"]}>
                          {dc}
                        </li>
                      );
                    })}
                  </ol>
                  {/* <p className={classes['day-text-desc']}>{it.desc}</p> */}
                </div>
                <img
                  className={classes["day-img-container"]}
                  src={it.img}
                  alt=""
                />
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};
